import { api } from 'app/sdk/utils/trunkingio';

const exports = {
    list: async (accountId, options) => {
        const response = await api.get(`/accounts/${accountId}/users`, options);
        return response.data;
    },
    get: async (accountId, userId, options) => {
        const response = await api.get(`/accounts/${accountId}/users/${userId}`, options);
        return response.data;
    },
    create: async (accountId, payload, options) => {
        const response = await api.put(`/accounts/${accountId}/users`, payload, options);
        return response.data;
    },
    patch: async (accountId, userId, payload, options) => {
        const response = await api.patch(`/accounts/${accountId}/users/${userId}`, payload, options);
        return response.data;
    },
    delete: async (accountId, userId, options) => {
        const response = await api.delete(`/accounts/${accountId}/users/${userId}`, options);
        return response.data;
    },
};

export default exports;
